package matekit.website.ui

import androidx.compose.ui.graphics.Color

val matekitcolor = Color(0xFFff7b00)